import axios from 'axios';

import reduxLayer from '../configureStore';
import { isMockingUser, getUserId } from '../helpers/user_helpers';

const APIClient = () => {
  const options = {
    baseURL: process.env.REACT_APP_API_URL,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const instance = axios.create(options);

  instance.interceptors.request.use(
    (config) => {
      // If we have a mock user, add the special handling
      const user = reduxLayer.store?.getState()?.user;

      if (!isMockingUser(user)) return config;

      // Do something before request is sent
      const mockUserId = getUserId(user);
      config.headers['impersonate-user-id'] = mockUserId;

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};

export default APIClient();
